export default {
    'INSERIR_TIPOLOGRADOURO' (state, payload) {
     state.tipos = payload;
    }
}